<span>
  <ng-content></ng-content>
  <rt-dot *ngIf="isUnread" color="unread"></rt-dot>

  <rt-badge
    *ngIf="(count | typeof) === 'string' || $any(count) > 0"
    margin-left-small-x
    color="counter-default"
    [text]="count"
  >
  </rt-badge>
</span>

<ng-container *ngIf="hrefTarget && href">
  <a [href]="href" target="{{ hrefTarget }}"></a>
</ng-container>
<ng-container *ngIf="!hrefTarget && href">
  <a [href]="href"></a>
</ng-container>
